import { render, staticRenderFns } from "./PekerjaanSidebar.vue?vue&type=template&id=457eb327&"
import script from "./PekerjaanSidebar.vue?vue&type=script&lang=js&"
export * from "./PekerjaanSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports